export const translations = {
  de: {
    // Navigation
    backToEvents: "Zurück zu Events",
    
    // Homepage
    nextEvent: "NÄCHSTES EVENT",
    days: "Tage",
    hours: "Stunden",
    minutes: "Minuten",
    seconds: "Sekunden",
    countdown: "Countdown",
    soon: "Bald",
    now: "JETZT",
    
    // Months
    months: [
      'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ],
    
    // Admin Login
    securityClearance: "Sicherheitsfreigabe",
    adminAccessRequired: "Admin-Zugang erforderlich",
    identificationCode: "Identifikationscode",
    enterUsername: "Benutzername eingeben...",
    securityKey: "Sicherheitsschlüssel",
    enterPassword: "Passwort eingeben...",
    requestAccess: "ZUGANG ANFORDERN",
    verifying: "VERIFIZIERE...",
    accessDenied: "Zugang verweigert - Ungültige Anmeldedaten",
    accessGranted: "Zugang gewährt - Willkommen, Commander",
    
    // Admin Dashboard
    adminPanel: "Admin Panel",
    commandCenter: "Kommandozentrale",
    events: "Events",
    users: "Benutzer",
    settings: "Einstellungen",
    viewSite: "Seite ansehen",
    logout: "Abmelden",
    
    // Event Management
    eventManagement: "Event-Verwaltung",
    eventsRegistered: "Events registriert",
    addEvent: "Event hinzufügen",
    editEvent: "Event bearbeiten",
    createNewEvent: "Neues Event erstellen",
    eventName: "Event-Name",
    month: "Monat",
    startDay: "Starttag",
    endDay: "Endtag",
    optional: "Optional",
    description: "Beschreibung",
    primaryColor: "Primärfarbe",
    secondaryColor: "Sekundärfarbe",
    imageUrl: "Bild-URL (Optional)",
    cancel: "Abbrechen",
    create: "Erstellen",
    update: "Aktualisieren",
    
    // User Management
    userManagement: "Benutzerverwaltung",
    adminsRegistered: "Admin(s) registriert",
    addAdmin: "Admin hinzufügen",
    createNewAdmin: "Neuen Admin erstellen",
    username: "Benutzername",
    password: "Passwort",
    changePassword: "Passwort ändern",
    changePasswordFor: "Passwort ändern für",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordChanged: "Passwort erfolgreich geändert",
    passwordsNotMatch: "Passwörter stimmen nicht überein",
    passwordMinLength: "Passwort muss mindestens 6 Zeichen haben",
    
    // Settings
    siteSettings: "Seiteneinstellungen",
    configureContent: "Webseiteninhalt konfigurieren",
    homepage: "Startseite",
    siteTitle: "Seitentitel",
    heroSubtitle: "Hero-Untertitel",
    footerText: "Fußzeilentext",
    backgroundImage: "Hintergrundbild-URL",
    loginPage: "Login-Seite",
    loginTitle: "Login-Titel",
    loginSubtitle: "Login-Untertitel",
    protocolText: "Protokoll-Text (Fußzeile)",
    loginButtonText: "Login-Button-Text",
    saveAllSettings: "Alle Einstellungen speichern",
    settingsSaved: "Einstellungen gespeichert",
    
    // Loading states
    initializingSystems: "SYSTEME WERDEN INITIALISIERT...",
    loadingCommandCenter: "KOMMANDOZENTRALE WIRD GELADEN...",
    verifyingCredentials: "ANMELDEDATEN WERDEN VERIFIZIERT...",
  },
  
  en: {
    // Navigation
    backToEvents: "Back to Events",
    
    // Homepage
    nextEvent: "NEXT EVENT",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    countdown: "Countdown",
    soon: "Soon",
    now: "NOW",
    
    // Months
    months: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ],
    
    // Admin Login
    securityClearance: "Security Clearance",
    adminAccessRequired: "Admin Access Required",
    identificationCode: "Identification Code",
    enterUsername: "Enter username...",
    securityKey: "Security Key",
    enterPassword: "Enter password...",
    requestAccess: "REQUEST ACCESS",
    verifying: "VERIFYING...",
    accessDenied: "Security clearance denied - Invalid credentials",
    accessGranted: "Access granted - Welcome, Commander",
    
    // Admin Dashboard
    adminPanel: "Admin Panel",
    commandCenter: "Command Center",
    events: "Events",
    users: "Users",
    settings: "Settings",
    viewSite: "View Site",
    logout: "Logout",
    
    // Event Management
    eventManagement: "Event Management",
    eventsRegistered: "events registered",
    addEvent: "Add Event",
    editEvent: "Edit Event",
    createNewEvent: "Create New Event",
    eventName: "Event Name",
    month: "Month",
    startDay: "Start Day",
    endDay: "End Day",
    optional: "Optional",
    description: "Description",
    primaryColor: "Primary Color",
    secondaryColor: "Secondary Color",
    imageUrl: "Image URL (Optional)",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    
    // User Management
    userManagement: "User Management",
    adminsRegistered: "admin(s) registered",
    addAdmin: "Add Admin",
    createNewAdmin: "Create New Admin",
    username: "Username",
    password: "Password",
    changePassword: "Change Password",
    changePasswordFor: "Change Password for",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordChanged: "Password changed successfully",
    passwordsNotMatch: "Passwords do not match",
    passwordMinLength: "Password must be at least 6 characters",
    
    // Settings
    siteSettings: "Site Settings",
    configureContent: "Configure website content",
    homepage: "Homepage",
    siteTitle: "Site Title",
    heroSubtitle: "Hero Subtitle",
    footerText: "Footer Text",
    backgroundImage: "Background Image URL",
    loginPage: "Login Page",
    loginTitle: "Login Title",
    loginSubtitle: "Login Subtitle",
    protocolText: "Protocol Text (Footer)",
    loginButtonText: "Login Button Text",
    saveAllSettings: "Save All Settings",
    settingsSaved: "Settings saved",
    
    // Loading states
    initializingSystems: "INITIALIZING SYSTEMS...",
    loadingCommandCenter: "LOADING COMMAND CENTER...",
    verifyingCredentials: "VERIFYING CREDENTIALS...",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
